import { render, staticRenderFns } from "./CreateToolKit.vue?vue&type=template&id=5c0b3147"
import script from "./CreateToolKit.vue?vue&type=script&lang=ts"
export * from "./CreateToolKit.vue?vue&type=script&lang=ts"
import style0 from "./CreateToolKit.vue?vue&type=style&index=0&id=5c0b3147&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports